// extracted by mini-css-extract-plugin
export default {"body":"EditarEventoPage_body__XL5VX"};